import { memo } from "react";

import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

import type { MessageTemplate } from "../../messageTemplates/types";
import {
  formatTemplateDisplayName,
  getStatusUi,
  templateStatusChipSx,
} from "../../messageTemplates/utils/messageTemplateUiUtils";

export interface AutomationConfiguredTemplateSummaryProps {
  template: MessageTemplate;
  organizationId: string;
  onViewTemplate?: () => void;
}

const AutomationConfiguredTemplateSummary = memo(
  ({
    template,
    organizationId,
    onViewTemplate,
  }: AutomationConfiguredTemplateSummaryProps) => {
    const displayName = formatTemplateDisplayName(template.name, {
      organizationPrefix: organizationId,
    });
    const statusUi = getStatusUi(template.status);

    return (
      <Stack
        direction="row"
        spacing={1}
        alignItems="center"
        sx={{ minWidth: 0 }}
      >
        <WhatsAppIcon fontSize="small" color="success" sx={{ flexShrink: 0 }} />
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {displayName}
        </Typography>
        <Chip
          label={statusUi.label}
          color={statusUi.color}
          size="small"
          variant="outlined"
          sx={{ flexShrink: 0, ...templateStatusChipSx }}
        />
        {onViewTemplate ? (
          <Button
            variant="text"
            size="small"
            startIcon={<VisibilityOutlinedIcon fontSize="small" />}
            onClick={onViewTemplate}
            sx={{ textTransform: "none", minWidth: 0, px: 0.75, flexShrink: 0 }}
          >
            Visualizar
          </Button>
        ) : null}
      </Stack>
    );
  },
);

AutomationConfiguredTemplateSummary.displayName = "AutomationConfiguredTemplateSummary";

export default AutomationConfiguredTemplateSummary;
